//
// Javascript for the jQueryTabs control
//
//  Ben Ramey
//  April 2010
//
HEIJS.registerNamespace("HEIJS.Controls");
HEIJS.Controls.jQueryTabs = function ()
{
  $("div.jquery-tabs").each(function ()
  {
    var options = {};

    // saving selected index across postbacks?
    var selectedIndexHidden = $(this).find("input[id$=selectedTabHidden]");
    if (selectedIndexHidden.length > 0)
    {
      $.extend(options, {
        active: parseInt(selectedIndexHidden.val()),
        activate: function (e, ui) { selectedIndexHidden.val(ui.newTab.index()); }
      });
    }

    $(this).tabs(options);
  }).show();
};

$(document).ready(function() { new HEIJS.Controls.jQueryTabs(); });